/**
 * Copyright (c) 2022 Strategio Digital s.r.o.
 * @author Jiří Zapletal (https://strategio.digital, jz@strategio.digital)
 */

import * as yup from 'yup'
import { defineRule } from 'vee-validate'
import { timeHelper } from '@/helpers/timeHelper'

const { isValidCzechDate, isValidCzechDateTime } = timeHelper()

yup.addMethod(yup.string, 'czechDate', function (errorMessage = 'Neplatný formát. Př: 1. 1. 2022') {
    return this.test('test-czech-date', errorMessage, function (value) {
        const { path, createError } = this
        return (value && isValidCzechDate(value)) || createError({ path, message: errorMessage })
    })
})

yup.addMethod(yup.string, 'czechDateTime', function (errorMessage = 'Neplatný formát. Př: 1. 1. 2022 09:05:05') {
    return this.test('test-czech-date-time', errorMessage, function (value) {
        const { path, createError } = this
        return (value && isValidCzechDateTime(value)) || createError({ path, message: errorMessage })
    })
})

defineRule('czech_date', (value: string) => {
    if (! value || ! value.length) {
        return true
    }

    if (! isValidCzechDate(value)) {
        return 'Neplatný formát. Př: 1. 1. 2022'
    }

    return true
})

defineRule('czech_dateTime', (value: string) => {
    if (! value || ! value.length) {
        return true
    }

    if (! isValidCzechDateTime(value)) {
        return 'Neplatný formát. Př: 1. 1. 2022 09:05:05'
    }

    return true
})